import { render, staticRenderFns } from "./ScreenCodeTabs.vue?vue&type=template&id=7973d862&scoped=true"
import script from "./ScreenCodeTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenCodeTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScreenCodeTabs.vue?vue&type=style&index=0&id=7973d862&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973d862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7973d862')) {
      api.createRecord('7973d862', component.options)
    } else {
      api.reload('7973d862', component.options)
    }
    module.hot.accept("./ScreenCodeTabs.vue?vue&type=template&id=7973d862&scoped=true", function () {
      api.rerender('7973d862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreenCodeTabs.vue"
export default component.exports